export enum TrackingCalledSectionMenuEnum {
    MENU_SETTINGS,
    MENU_CLOSE,
    MENU_START,
    MENU_PRODUCTS,
    MENU_SOLUTIONS,
    MENU_NEWS,
    MENU_BROTHER_INTERACTIVE,
    MENU_BROTHER_PRINTSMART,
    MENU_BROTHER_PRINTSMART_PPPB,
    MENU_BROTHER_PRINTSMART_PPPB_CONTRACTS,
    MENU_BROTHER_PRINTSMART_PPPB_ORDERS,
    MENU_BROTHER_PRINTSMART_PRJ_MPS,
    MENU_BROTHER_CSP,
    MENU_BROTHER_CSP_CONNECTED,
    MENU_PROJECTS,
    MENU_CONTACT,
    MENU_MORE,
    MENU_BROTHER_DEALER_PORTAL,
    MENU_BROTHER_USER_MANAGEMENT,
    MENU_BROTHER_TERMS_OF_USE,
    MENU_BROTHER_DATA_PRIVACY,
    MENU_BROTHER_TERMS_AND_CONDITIONS,
    MENU_BROTHER_IMPRINT,

    MENU_SALES_DASHBOARD,
    MENU_SERVICE,
    MENU_DOCUMENT_BASKET,
    MENU_INTERNAL_DASHBOARD,

    MENU_USER_MANAGEMENT
}
